// Cuadre del acta E-14:
// - la suma total (candidatos + blanco + nulos + no marcados) debe ser igual
//   a los votos de la urna menos los incinerados
// - los votos que quedan en la urna no pueden superar los votantes del E-11
const aNumero = (valor) => Number(valor) || 0;

export const calcularNivelacion = (totales, votosCandidatos) => {
  const sumaCandidatos = votosCandidatos.reduce((suma, votos) => suma + aNumero(votos), 0);
  const sumaTotal =
    sumaCandidatos +
    aNumero(totales.votosBlanco) +
    aNumero(totales.votosNulos) +
    aNumero(totales.votosNoMarcados);
  const votosValidosUrna = aNumero(totales.totalVotosUrna) - aNumero(totales.votosIncinerados);

  const novedades = [];
  if (votosValidosUrna > aNumero(totales.totalVotantesE11)) {
    novedades.push("Hay más votos en la urna (menos incinerados) que votantes en el E-11.");
  }
  if (sumaTotal !== votosValidosUrna) {
    novedades.push(
      `La suma del acta (${sumaTotal}) no coincide con los votos de la urna menos incinerados (${votosValidosUrna}).`
    );
  }

  return { sumaTotal, votosValidosUrna, cuadra: novedades.length === 0, novedades };
};
